import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import { InactivityService } from '../../services';

import {
  types as actions,
  getOrgs
} from '../../reducers/actions';

export default function(action$) {
  return action$.pipe(
    ofType(actions.LOGGED_IN),
    switchMap(action => {
      const action$ = InactivityService.start();
      return concat(
        of(getOrgs()),
        action$
      );
    })
  );
}



// WEBPACK FOOTER //
// ./src/epics/auth/loggedIn.js